import moment from 'moment';
import jp from 'jsonpath';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';

const getTimeIndices = (startDate: string, endDate: string) => {
  let currentDate: any = moment(startDate);
  let stopDate: any = moment(endDate);
  var dateArray = [];
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
};
const getSimulationFields = (configFields: any, mode?: any) => {
  const fields = formatString(configFields);
  fields?.map((field: any) => {
    field.size = 3;
    field.label = field.displayName;
    field.disabled = mode ? field.disabled : false;
    field.defaultValue = mode ? field?.defaultValue : null;
    if (field?.path) {
      const keys = field?.path?.split('.');
      field.key = keys[keys?.length - 1];
    } else {
      field.key = field.name;
    }
    if (field?.required) {
      field['rules'] = {
        required: {
          value: true,
          message: `${field?.displayName} is Required`
        }
      };
    }
    if (field.type === 'String') field.type = 'text';
    if (field.type === 'TextArea') {
      field.type = 'textarea';
      field.size = 12;
      field.labelStyleType = 'tetxareaLabel';
    } else if (field.type === 'Integer') field.type = 'number';
    else if (field.type === 'Enum' || field.type === 'MultiEnum') {
      let defaultValue: any = field.defaultValue;
      if (field.type === 'MultiEnum') {
        let required = true;
        field['rules'] = {
          required: {
            value: required,
            message: `${field?.displayName} is Required`
          },
          validate: {
            length: (file: any) => !required || file.length > 0 || `${field?.displayName} is Required`
          }
        };
        defaultValue = [];
        field['multiple'] = true;
      }
      field.type = 'dropdown';
      field.labelStyleType = 'InputLabel';
      field.values = field?.enumValues?.map((val: string) => ({ label: val, value: val }));
      field.defaultValue = defaultValue;
    } else if (field.type === 'Date') field.type = 'date';
    else if (field.type === 'Boolean') {
      field.type = 'dropdown';
      field.values = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ];
      field.labelStyleType = 'InputLabel';
      field.defaultValue = field.defaultValue ? field.defaultValue : false;
    }
  });
  return fields;
};

const getInputField = (fields: any, formData: any, input: any) => {
  fields.map((field: any) => {
    const key = field?.hide ? field.mapFromPath : field.key;
    if (formData.hasOwnProperty(key) && !field?.hide) {
      jp.apply(input, `$.${field?.path}`, (value: any) => {
        if (field.type === 'date') {
          if (formData[key]) localStorage.setItem(key, moment(formData[key]).format('YYYY-MM-DDTHH:mm:ss[Z]'));
          return formData[key] ? moment(formData[key]).format('YYYY-MM-DDTHH:mm:ss[Z]') : null;
        } else if (field.type === 'number') {
          localStorage.setItem(key, formData[key] || field.defaultValue || '');
          return parseInt(formData[key]) || parseInt(field.defaultValue);
        }
        localStorage.setItem(key, formData[key] || field.defaultValue || '');
        return formData[key] || field.defaultValue;
      });
    } else if (field?.hide) {
      jp.apply(input, `$.${field?.path}`, (value: any) => {
        return formData[key];
      });
    }
  });
  return input;
};

const Accordion = withStyles(theme => ({
  root: {
    boxShadow: 'none',
    width: '100%',
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
      color: '#635e5e'
    },
    '&:before': {
      display: 'none'
    }
  },
  expanded: {}
}))(MuiAccordion);

const AccordionSummary = withStyles(theme => ({
  root: {
    '& .MuiTypography-root': {
      fontWeight: 500,
      color: '#000'
    },
    background: '#f5f5f5',
    borderRadius: '10px',
    marginBottom: theme.spacing(-0.125),
    minHeight: theme.spacing(6),
    '&$expanded': {
      minHeight: theme.spacing(6)
    }
  },
  content: {
    '&$expanded': {
      margin: theme.spacing(1.5, 0)
    }
  },
  expanded: {}
}))(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(0, 2, 2, 2),
    background: '#f5f5f5'
  }
}))(MuiAccordionDetails);

const formatString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return str;
  }
  return JSON.parse(str);
};

export {
  getTimeIndices,
  getSimulationFields,
  getInputField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  formatString
};
